/* eslint-ignore */
// @ts-nocheck
import React from "react";

import {
  Container,
  TolltipItens,
  TooltipContainer,
  TooltipFormated,
  TootipTitle,
} from "./styles";

type CustomTooltipProps = {
  title: string;
  className?: string;
  children: React.ReactNode;
};

const CustomToolip: React.FC<CustomTooltipProps> = ({
  title,
  className,
  children,
}) => {
  return (
    <Container className={className}>
      {children}
      <TooltipContainer>
        <TootipTitle>{title}</TootipTitle>
        <TolltipItens>
          Atualize o endereço de correspondência no menu Boletos, em
          <TooltipFormated to="/preferencia-cobranca">
            Preferências de cobrança.
          </TooltipFormated>
        </TolltipItens>
      </TooltipContainer>
    </Container>
  );
};

export default CustomToolip;
